<template>
  <b-modal
    centered
    scrollable
    hide-footer
    size="xl"
    v-if="show && tableConfig"
    v-model="show"
    :title="data.app_name"
    title-tag="h3"
  >
    <div>
      <b-form-group label="起止时间" label-class="font-weight-bold">
        {{ data.ins_start_time }} ~ {{ data.ins_end_time }}
      </b-form-group>
      <b-form-group label="登录方式" label-class="font-weight-bold">
        <template v-if="data.login_conf.login_way > 0">
          <template v-for="(item, key, idx) in login_conf_options">
            <b-form-checkbox :key="idx" v-if="(data.login_conf.login_way & 1 << item.login_base_num) > 0" checked="true" disabled>
              {{ item.text }}
              <div>
                <b-list-group horizontal>
                  <b-list-group-item v-for="(conf_item, conf_idx) in item.conf" :key="conf_idx">
                    {{ conf_item.text }}：<strong>{{ data.login_conf[key][conf_item.conf_key] }}</strong>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-form-checkbox>
          </template>
        </template>
        <template v-else>
          <h6 class="inline-block">{{ no_conf_text }}</h6>
        </template>
      </b-form-group>
      <b-form-group label="数据表配置" label-class="font-weight-bold">
        <b-table responsive="sm" :items="tableConfig.fields" :fields="tableFields" >
          <template #cell(field)="data">
            {{ data.item.field }} <i v-if="data.item.field === tableConfig.primary_key" class="fa fa-key text-danger" />
          </template>
        </b-table>
        <div>
          唯一索引：
          <template v-if="tableConfig.unique_keys.length > 0">
            <h5 v-for="(item, idx) in tableConfig.unique_keys" class="inline-block" :key="idx"><b-badge variant="primary">{{ item[0] }}</b-badge></h5>
          </template>
          <template v-else>
            <h6 class="inline-block">{{ no_conf_text }}</h6>
          </template>
        </div>
        <div>
          索引：
          <template v-if="tableConfig.index.length > 0">
            <h5 v-for="(item, idx) in tableConfig.index" class="inline-block" :key="idx"><b-badge variant="primary">{{ item.join(',') }}</b-badge></h5>
          </template>
          <template v-else>
            <h6 class="inline-block">{{ no_conf_text }}</h6>
          </template>
        </div>
      </b-form-group>
      <b-form-group label="投票前强制绑定" label-class="font-weight-bold">
        <template v-if="data.bind_config && data.bind_config.bind_way > 0">
          <template v-if="data.bind_config.bind_way > 0" v-for="(item, key, idx) in bind_conf_options">
            <b-form-checkbox :key="idx" :checked="!!(data.bind_config.bind_way & 1 << item.bind_base_num)" disabled>
              {{ item.text }}
              <div v-if="!!(data.bind_config.bind_way & 1 << item.bind_base_num)">
                <b-list-group horizontal>
                  <b-list-group-item v-for="(conf_item, conf_idx) in item.conf" :key="conf_idx">
                    {{ conf_item.text }}：<strong>{{ data.bind_config[key][conf_item.conf_key] }}</strong>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-form-checkbox>
          </template>
        </template>
        <template v-else>
          <h6 class="inline-block">{{ no_conf_text }}</h6>
        </template>
      </b-form-group>
      <b-form-group label="投票项拉取配置" label-class="font-weight-bold">
        <template v-if="!!data.is_pull">
          <template v-for="(item, idx) in pullConfigParams">
            <b-form-group label-cols="2" :key="idx" :label="item.text + '：'" label-align="right">
              <template v-if="item.tag.search('external') !== -1">
                <strong v-if="item.external_field === 'id_page'">{{ data.pull_config.limit_config[item.external_field] ? 'ID' : '页标' }}</strong>
                <strong v-else>{{ data.pull_config.limit_config[item.external_field] }}</strong>
              </template>
              <template v-else>
                <strong v-if="item.field === 'sign_params'">{{ data.pull_config[item.field].join(',') }}</strong>
                <strong v-else>{{ data.pull_config[item.field] }}</strong>
              </template>
            </b-form-group>
          </template>
        </template>
        <template v-else>{{ no_conf_text }}</template>
      </b-form-group>
      <b-form-group label="默认投票限制" label-class="font-weight-bold">
        <b-form inline>
          <label class="mr-sm-2">单个用户总投票数：</label>
          <strong>{{ data.limit_config.limit_vote_num }}</strong>
        </b-form>
        <b-form-group label="限制方式：">
          <template v-if="data.limit_config.is_limit > 0">
            <template v-for="(item, key, idx) in limit_conf_options">
              <b-form-checkbox :key="idx" :checked="!!(data.limit_config.is_limit & item.type)" disabled>
                {{ item.text }}
                <template v-if="!!(data.limit_config.is_limit & item.type)">
                  <b-list-group>
                    <b-list-group-item v-for="(conf_item, conf_idx) in item.conf" :key="conf_idx">
                      {{ conf_item.text }}
                      <strong v-if="conf_item.extra_key">{{ data.limit_config[conf_item.conf_key] !== '-1' ? data.limit_config[conf_item.conf_key] : '不限' }}</strong>
                      <strong v-else>
                        {{ limit_config_text[data.limit_config[conf_item.conf_key]] }}
                        {{ data.limit_config[conf_item.conf_key].toString() === '3' ? data.limit_config.refresh_time : '' }}
                      </strong>
                    </b-list-group-item>
                  </b-list-group>
                </template>
              </b-form-checkbox>
            </template>
          </template>
          <template v-else>
            <h6 class="inline-block">{{ no_conf_text }}</h6>
          </template>
        </b-form-group>
        <b-form inline>
          <label class="mr-sm-2">限定时间：</label>
          <strong>{{ limit_config_start_time }} {{ limit_config_end_time }}</strong>
        </b-form>
      </b-form-group>
      <b-form-group label="易盾配置" label-class="font-weight-bold">
        <template v-if="data.yidun_config && Object.keys(data.yidun_config).length > 0">
          <template v-for="(item, idx) in yidunConfigParams">
            <b-form-group label-cols="2" :key="idx" :label="item.text + '：'" label-align="right">
              <strong>{{ data.yidun_config[item.field] }}</strong>
            </b-form-group>
          </template>
        </template>
        <template v-else>{{ no_conf_text }}</template>
      </b-form-group>
    </div>
  </b-modal>
</template>

<script>
import consts from '../../utils/consts'

export default {
  name: 'vote-detail',
  props: ['showData'],
  data () {
    return {
      data: {
        app_name: ''
      },
      show: false,
      tableConfig: null,
      tableFields: consts.VOTE_DEFAULT_TABLE_CONFIG,
      pullConfigParams: consts.VOTE_PULL_CONFIG_PARAMS,
      limit_config_text: consts.LIMIT_CONFIG_TEXT,
      login_conf_options: consts.VOTE_DETAIL_LOGIN_CONF,
      yidunConfigParams: consts.VOTE_YIDUN_CONFIG_PARAMS,
      bind_conf_options: consts.VOTE_DETAIL_BIND_CONF,
      limit_conf_options: consts.VOTE_DETAIL_LIMIT_CONF,
      no_conf_text: '未配置'
    }
  },
  created () {},
  methods: {
    modalShow () {
      this.show = true
    }
  },
  computed: {
    limit_config_start_time: function () {
      let front = this.data.limit_config.limit_start_time.split('-').slice(0, 3).join('-')
      let behind = this.data.limit_config.limit_end_time.split('-').slice(0, 3).join('-')
      return front + '~' + behind
    },
    limit_config_end_time: function () {
      let front = this.data.limit_config.limit_start_time.split('-').slice(3).join(':')
      let behind = this.data.limit_config.limit_end_time.split('-').slice(3).join(':')
      return front + '~' + behind
    }
  },
  watch: {
    showData (val) {
      this.data = val
      for (let key in val.table_config) {
        if (key.indexOf('list') !== -1) {
          let tableConfig = {
            primary_key: val.table_config[key].primary_key[0],
            unique_keys: val.table_config[key].unique_keys,
            index: val.table_config[key].index
          }
          let tableItems = []
          for (let idx in val.table_config[key].fields) {
            let item = val.table_config[key].fields[idx]
            tableItems.push({
              field: item.field,
              type: item.type,
              field_len: item.field_len,
              null: item.null,
              default: item.default
            })
            tableConfig.fields = tableItems
            this.tableConfig = tableConfig
          }
        }
      }
    }
  }
}
</script>

<style>
  .inline-block {
    display: inline;
  }
  .form-row {
    align-items: center !important;
  }
  .badge {
    margin-right: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// VoteDetail.vue?b5d73f32